/**
 * ConfigService - Handles configuration API operations
 */
export class ConfigService {
  constructor(apiClient) {
    this.apiClient = apiClient;
    console.log('ConfigService initialized');
  }

  /**
   * Fetch configuration data from the server
   * @returns {Promise<Object>} Configuration data
   */
  async fetchConfig() {
    return this.apiClient.get('/api/config/fetch');
  }

  /**
   * Clinical department SNOMED codes available for documents (requires DOCS_READ).
   * @returns {Promise<Record<string, { code: string, terms: string[], is_qof?: boolean }>>}
   */
  async fetchClinicalDepartmentsForDocument() {
    return this.apiClient.get('/api/config/document/clinical_departments/fetch');
  }

  /**
   * Letter type SNOMED codes available for documents (requires DOCS_READ).
   * @returns {Promise<Record<string, { code: string, terms: string[], is_qof?: boolean }>>}
   */
  async fetchLetterTypesForDocument() {
    return this.apiClient.get('/api/config/document/letter_types/fetch');
  }

  /**
   * Update configuration on the server
   * @param {Object} configData - The configuration data to update
   * @returns {Promise<Object>} The updated configuration
   */
  async updateConfig(configData) {
    try {
      return await this.apiClient.post('/api/config/update', configData);
    } catch (error) {
      // Some config endpoints may return non-JSON responses
      console.warn('Config update response may not be JSON:', error);
      return { success: true, message: 'Configuration updated successfully' };
    }
  }
}

